<pbc-filter [config]="ArchivFilterConfig" [filter]="archiv.filter$ | async" (filterChange)="archiv.filter$.next($event)"></pbc-filter>
